/* Predicción Mundialista Serené — storefront logic (vanilla JS) */
(function () {
  var app = document.getElementById('pm-app');
  if (!app) return;
  var PROXY = app.dataset.proxy;
  var TOKEN = app.dataset.token || '';
  var EMAIL = app.dataset.email || localStorage.getItem('pm_email') || '';
  var timers = [];
  var picks = {};          // matchId -> 'team_a' | 'draw' | 'team_b'
  var matchInfo = {};      // matchId -> { teamA, teamB }

  function hdr(extra) { var h = { 'x-pm-token': TOKEN }; if (extra) for (var k in extra) h[k] = extra[k]; return h; }
  function track(ev, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: ev }, data)); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', ev, data || {}); } catch (e) {}
  }
  function money(n) { return '$' + Number(n || 0).toLocaleString('es-CO'); }
  function plu(n) { return n === 1 ? 'predicción' : 'predicciones'; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function statusLabel(m) {
    if (m.status === 'open') return '<span class="pm-tag pm-tag--open">Predicción abierta</span>';
    if (m.status === 'closed' || m.status === 'live') return '<span class="pm-tag pm-tag--closed">Este partido ya empezó. Predicción cerrada.</span>';
    if (m.status === 'final') return '<span class="pm-tag pm-tag--final">Resultado final</span>';
    if (m.status === 'cancelled') return '<span class="pm-tag pm-tag--closed">Partido cancelado</span>';
    return '';
  }

  function renderMatches(data) {
    var box = document.getElementById('pm-matches-list');
    if (!data.matches || !data.matches.length) {
      box.innerHTML = '<p class="pm-empty">Hoy no hay partidos programados. ¡Vuelve mañana!</p>';
      updateConfirmBar();
      return;
    }
    box.innerHTML = data.matches.map(function (m) {
      matchInfo[m.id] = { teamA: m.teamA, teamB: m.teamB };
      var open = m.status === 'open';
      // la predicción previa guardada manda; si no, lo que el usuario eligió en esta sesión
      var picked = m.myPrediction || picks[m.id] || null;
      if (picked) picks[m.id] = picked;
      var chips = '';
      if (open) {
        chips = '<div class="pm-chips">' +
          chip(m.id, 'team_a', 'Gana ' + m.teamA, picked === 'team_a') +
          chip(m.id, 'draw', 'Empate', picked === 'draw') +
          chip(m.id, 'team_b', 'Gana ' + m.teamB, picked === 'team_b') + '</div>';
      }
      var score = (m.status === 'final') ? '<div class="pm-score">' + m.scoreA + ' - ' + m.scoreB + '</div>' : '';
      var cd = open ? '<div class="pm-countdown" data-kick="' + m.kickoffIso + '"></div>' : '';
      var mine = picked ? '<p class="pm-mine">Tu predicción: <strong>' + label(m, picked) + '</strong>' + (open ? ' · podés cambiarla antes del partido' : '') + '</p>' : '';
      var result = (m.status === 'final' && picked) ? (m.correctResult === picked
        ? '<p class="pm-win">¡Acertaste! 🎉</p>' : '<p class="pm-lose">Esta vez no acertaste.</p>') : '';
      return '<article class="pm-match' + (open ? '' : ' pm-match--closed') + '">' +
        '<div class="pm-match__head">' + statusLabel(m) + '<span class="pm-match__time">' + m.kickoffBogota + '</span></div>' +
        '<div class="pm-match__teams"><span>' + logo(m.teamALogo) + m.teamA + '</span>' + score + '<span>' + m.teamB + logo(m.teamBLogo) + '</span></div>' +
        cd + chips + mine + result + '</article>';
    }).join('');
    startCountdowns();
    updateConfirmBar();
  }
  function logo(u) { return u ? '<img class="pm-logo" src="' + u + '" alt="" loading="lazy">' : ''; }
  function label(m, p) { return p === 'team_a' ? 'Gana ' + m.teamA : p === 'team_b' ? 'Gana ' + m.teamB : 'Empate'; }
  function chip(id, val, text, on) {
    return '<button type="button" class="pm-chip' + (on ? ' is-on' : '') + '" data-match="' + id + '" data-pred="' + val + '">' + text + '</button>';
  }

  function startCountdowns() {
    timers.forEach(clearInterval); timers = [];
    document.querySelectorAll('.pm-countdown').forEach(function (el) {
      var kick = new Date(el.dataset.kick).getTime();
      function tick() {
        var diff = kick - Date.now();
        if (diff <= 0) { el.textContent = 'Predicción cerrada'; el.classList.add('is-closed'); return; }
        var h = Math.floor(diff / 3.6e6), m = Math.floor(diff % 3.6e6 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        el.textContent = (diff < 18e5 ? 'Últimos minutos para predecir · ' : 'Cierra en ') + pad(h) + ':' + pad(m) + ':' + pad(s);
        el.classList.toggle('is-urgent', diff < 18e5);
      }
      tick(); timers.push(setInterval(tick, 1000));
    });
  }

  // --- Selección de predicciones (sin formulario por partido) ---
  function countPicks() { return Object.keys(picks).length; }
  function updateConfirmBar() {
    var n = countPicks();
    var btn = document.getElementById('pm-confirm');
    var sLabel = document.getElementById('pm-sticky-label');
    var sBtn = document.getElementById('pm-sticky-btn');
    if (btn) { btn.hidden = n === 0; btn.textContent = 'Confirmar mis ' + n + ' ' + plu(n); }
    if (sLabel) sLabel.textContent = n > 0 ? (n + ' ' + plu(n) + ' lista' + (n === 1 ? '' : 's')) : 'Bono de hoy: hasta $30.000';
    if (sBtn && !sBtn.dataset.reward) sBtn.textContent = n > 0 ? 'Confirmar (' + n + ')' : 'Predecir ahora';
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest('.pm-chip'); if (!c) return;
    var id = c.dataset.match, pred = c.dataset.pred;
    var siblings = c.parentNode.querySelectorAll('.pm-chip');
    if (picks[id] === pred) {            // re-click = deseleccionar
      delete picks[id];
      siblings.forEach(function (s) { s.classList.remove('is-on'); });
    } else {
      picks[id] = pred;
      siblings.forEach(function (s) { s.classList.toggle('is-on', s.dataset.pred === pred); });
    }
    track('SelectPrediction', { match_id: id, prediction: pred });
    updateConfirmBar();
  });

  // --- Form modal (una sola vez para todas las predicciones) ---
  var modal = document.getElementById('pm-form-modal');
  var form = document.getElementById('pm-form');
  function openForm() {
    if (countPicks() === 0) return;
    var n = countPicks();
    var list = Object.keys(picks).map(function (id) {
      var mi = matchInfo[id] || {}; return '• ' + label({ teamA: mi.teamA, teamB: mi.teamB }, picks[id]);
    }).join('<br>');
    document.getElementById('pm-form-pick').innerHTML = 'Vas a guardar <strong>' + n + '</strong> ' + plu(n) + ':<br>' + list;
    document.getElementById('pm-form-msg').textContent = '';
    modal.hidden = false;
  }
  function openFromTrigger() {
    if (countPicks() === 0) {
      document.getElementById('pm-partidos').scrollIntoView({ behavior: 'smooth' });
      return;
    }
    openForm();
  }
  document.getElementById('pm-confirm').onclick = openForm;
  modal.querySelector('.pm-modal__close').onclick = function () { modal.hidden = true; };
  modal.onclick = function (e) { if (e.target === modal) modal.hidden = true; };

  form.onsubmit = function (e) {
    e.preventDefault();
    var msg = document.getElementById('pm-form-msg'); msg.className = 'pm-form-msg'; msg.textContent = 'Guardando…';
    var payload = {
      predictions: Object.keys(picks).map(function (id) { return { matchId: id, prediction: picks[id] }; }),
      name: form.name.value, email: form.email.value, phone: form.phone.value,
    };
    track('SubmitPrediction', { count: payload.predictions.length });
    fetch(PROXY + '/predictions', { method: 'POST', headers: hdr({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok && (!res.j.saved || !res.j.saved.length)) { msg.textContent = res.j.message || 'No se pudo guardar. Revisá tus datos.'; return; }
        EMAIL = payload.email.toLowerCase(); localStorage.setItem('pm_email', EMAIL);
        track('PredictionConfirmed', { count: (res.j.saved || []).length });
        var saved = (res.j.saved || []).length;
        var rej = (res.j.rejected || []).filter(function (r) { return r.reason === 'closed'; }).length;
        msg.className = 'pm-form-msg is-ok';
        msg.innerHTML = '¡Listo! Guardamos <strong>' + saved + '</strong> ' + plu(saved) + '.' +
          (rej ? ' (' + rej + ' partido' + (rej === 1 ? '' : 's') + ' ya había empezado y no se incluyó.)' : '') +
          '<br>Cuando terminen los partidos, vuelve a esta página para ver si ganaste tu bono.';
        setTimeout(function () { modal.hidden = true; load(); }, 2200);
      })
      .catch(function () { msg.textContent = 'Error de conexión. Probá de nuevo.'; });
  };

  // --- Rewards ---
  function loadReward() {
    if (!EMAIL) return;
    fetch(PROXY + '/rewards?email=' + encodeURIComponent(EMAIL), { headers: hdr() }).then(function (r) { return r.json(); }).then(function (rw) {
      var box = document.getElementById('pm-reward'), sticky = document.getElementById('pm-sticky-label'), btn = document.getElementById('pm-sticky-btn');
      if (rw.status === 'won') {
        var triple = rw.totalCorrect >= 3;
        box.hidden = false;
        box.innerHTML = '<h2 class="pm-h2">' + (triple ? '¡Triplete mundialista!' : '¡Acertaste!') + '</h2>' +
          '<p class="pm-reward__amount">' + (triple ? 'Acertaste 3 resultados y ganaste ' : 'Ganaste ') + money(rw.amount) + ' COP en bono Serené.</p>' +
          '<p class="pm-reward__code">Código: <strong>' + rw.code + '</strong></p>' +
          '<p class="pm-reward__exp">Tu bono vence ' + (rw.expiresAtBogota ? 'el ' + rw.expiresAtBogota : 'en 24 horas') + '.</p>' +
          '<a class="pm-cta pm-cta--full" href="' + rw.redeemUrl + '">Usar mi bono ahora</a>';
        sticky.textContent = 'Tu bono: ' + money(rw.amount) + ' COP';
        btn.dataset.reward = '1';
        btn.textContent = 'Usar mi bono'; btn.setAttribute('href', rw.redeemUrl);
        track('BonusWon', { reward_amount: rw.amount, total_correct: rw.totalCorrect, discount_code: rw.code });
      } else if (rw.status === 'pending') {
        box.hidden = false;
        box.innerHTML = '<h2 class="pm-h2">Vas ' + rw.totalCorrect + ' acierto(s)</h2><p class="pm-sub">Cuando terminen todos tus partidos de hoy, emitimos tu bono. Vuelve a revisar.</p>';
      }
    }).catch(function () {});
  }

  function load() {
    fetch(PROXY + '/matches/today' + (EMAIL ? '?email=' + encodeURIComponent(EMAIL) : ''), { headers: hdr() })
      .then(function (r) { return r.json(); }).then(renderMatches).then(loadReward)
      .catch(function () { document.getElementById('pm-matches-list').innerHTML = '<p class="pm-empty">No pudimos cargar los partidos. Recargá la página.</p>'; });
  }

  // sticky / botón flotante también abre el formulario
  var sBtn = document.getElementById('pm-sticky-btn');
  if (sBtn) sBtn.addEventListener('click', function (e) { if (!sBtn.dataset.reward) { e.preventDefault(); openFromTrigger(); } });

  track('ViewPredictionPage', {});
  load();
  setInterval(load, 60000); // refresco cada minuto (estados/marcadores)
})();
